import { BookOpenCheckIcon, DropletIcon, FlaskConicalIcon, PowerIcon, SearchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Diesel Engine Troubleshooting Visual Guide',
    description: 'A visual symptom-to-cause guide for common diesel engine problems such as hard starting, abnormal smoke, low oil pressure and overheating.',
    icon: SearchIcon,
  },
  {
    number: '2',
    title: 'Generator Set Start-Up, Run & Shutdown Visual Guide',
    description: 'A visual sequence of the checks for starting, running and stopping a generator set.',
    icon: PowerIcon,
  },
  {
    number: '3',
    title: 'Diesel Fuel Storage & Fuel Quality Field Guide',
    description: 'A field reference for storing diesel fuel, recognizing contamination and keeping fuel in good condition.',
    icon: DropletIcon,
  },
  {
    number: '4',
    title: 'Oil & Coolant Analysis Interpretation Guide',
    description: 'How to read oil and coolant analysis reports and what common results can indicate.',
    icon: FlaskConicalIcon,
  },
  {
    number: '5',
    title: 'Diesel Engines & Generators Terminology Dictionary',
    description: 'An A–Z reference of the terms and acronyms used with diesel engines and generator sets.',
    icon: BookOpenCheckIcon,
  },
];
